import { useEffect } from "react";
import { preloadable, whenIdle } from "@/lib/preload";
import { ADM_QUERY } from "@/lib/useMediaQuery";
import type { NavigationDialog as Dialog } from "./navigation-dialog";

/**
 * The phone's navigation sheet: the header's Menu and a page's section
 * picker. One loader for both, so whichever is opened first warms the other.
 *
 * Kept out of the main chunk (the sheet pulls in Base UI's dialog, ~18 kB
 * gzip in its own chunks, measured 2026-09-14), but on a PHONE it is the
 * navigation, so it is fetched once the page is idle rather than on the tap
 * (`src/lib/preload.ts` for why the tap was not good enough). A laptop never
 * shows either control and never pays for it.
 */
export const navigationDialog = preloadable<Parameters<typeof Dialog>[0]>(() =>
  import("./navigation-dialog").then((m) => m.NavigationDialog),
);

/** Warm the sheet after the page settles, below the laptop breakpoint only. */
export function useWarmNavigationDialog(): void {
  useEffect(() => {
    if (window.matchMedia(ADM_QUERY).matches) return;
    return whenIdle(navigationDialog.warm);
  }, []);
}
